export default "__VITE_ASSET__D1OJQsHw__"